/**
 * Mensagem para quando uma chamada da Pluggy falha. O servidor já devolve o motivo ("O plano Grátis não inclui a conexão com o
 * Open Finance", "Credenciais Pluggy não configuradas.", limite de atualizações...): é ele que aparece. O texto de credenciais
 * só entra quando o motivo é realmente credencial; sem resposta do servidor (rede, tempo esgotado) a mensagem é de conexão.
 * (Cópia em Web/src/lib/pluggyErro.ts.)
 */
export function mensagemErroPluggy(erro: unknown, padrao = 'Não foi possível carregar as contas.'): string {
  const e = (erro ?? {}) as { message?: string; response?: { status?: number }; isAxiosError?: boolean; code?: string }
  const semResposta = e.response?.status === undefined
  if (semResposta && (e.isAxiosError || e.code === 'ECONNABORTED' || e.code === 'ERR_NETWORK')) {
    return 'Não foi possível falar com o servidor. Confira sua conexão e tente de novo.'
  }

  const msg = e.message?.trim()
  const base = msg && !/^Request failed with status code/i.test(msg) ? msg : padrao
  const ehCredencial = /credenciais/i.test(base) || /\b(401|403)\b/.test(base)
  if (!ehCredencial) return base
  return `${base}${/[.!?]$/.test(base) ? '' : '.'} Confira as credenciais Pluggy em Configurações.`
}
